import { render, staticRenderFns } from "./DoctorMaterial.vue?vue&type=template&id=5cf6fb5c&scoped=true"
import script from "./DoctorMaterial.vue?vue&type=script&lang=js"
export * from "./DoctorMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf6fb5c",
  null
  
)

export default component.exports